import Swiper from "swiper";
import { Navigation } from 'swiper/modules';

const initBooksSlider = () => {
    const blocks = Array.from(document.querySelectorAll('.block-books'));

    blocks.forEach(block => {
        if (block.inited) {
            return;
        }
        block.inited = true;

        new Swiper(block, {
            modules: [Navigation],
            loop: false,
            slidesPerView: 1.6,
            spaceBetween: 2,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
            // mobile + tablet - 320-990
            320: {
                slidesPerView: 1.1
            },
            // desktop >= 991
            1200: {
                slidesPerView: 1.6,
            }
            }
        });
    });
};

initBooksSlider();

export default initBooksSlider;
